import {
  AddressDTO,
  CustomerDTO,
  OnlineMbeConfigurationDTO,
  DepartmentDTO,
  CreateStoreDTO,
  OnlineMBEExtraServiceDto,
  OnlineMbeCourierVisibilityDto,
  OnlineMBEThermicConfigDto
} from "../../model/data.model";

// initial state
const state = {
  customerMbeId: "",
  info: {},
  config: {} as OnlineMbeConfigurationDTO,
  departments: [],
  storeAddresses: [],
  mbeServiceIds: [],
  storeInfo: {
    store: {
      multiStore: {}
    }
  },
  taxDutyEnabled: false,
  taxDutyZonosEnabled: false,
  extraServiceConfig: [],
  courierVisibilityConfig: [],
  thermicConfig: [],
  claimConfig: {}
};

// getters
const getters = {
  customerMbeId: (state: any) => state.customerMbeId,
  info: (state: any) => state.info,
  config: (state: any) => state.config,
  isSmartchoiceSettingAutopilot: (state: any) => {
    if (!state.config) return false;
    return state.config.smartChoiceSetting === "AUTOPILOT";
  },
  departments: (state: any) => state.departments,
  mbeServiceIds: (state: any) => state.mbeServiceIds,
  storeAddresses: (state: any) => state.storeAddresses,
  openingHours: (state: any) => state.openingHours,
  storeInfo: (state: any) => state.storeInfo,
  extraServiceConfig: (state: any) => state.extraServiceConfig,
  courierVisibilityConfig: (state: any) => state.courierVisibilityConfig,
  thermicConfig: (state: any) => state.thermicConfig,
  hasAnyEcommerce: (state: any) => {
    return (
      state.config.ebayEnabled === true ||
      state.config.amazonEnabled === true ||
      state.config.translateElinkServiceCode === true
    );
  },
  isTaxDutyEnabled: (state: any) => {
    return state.taxDutyEnabled;
  },
  isTaxDutyZonosEnabled: (state: any) => {
    return state.taxDutyZonosEnabled;
  },
  claimConfig: (state: any) => {
    return state.claimConfig;
  }
};

// mutations
const mutations = {
  setCustomerMbeId: (state: any, customerMbeId: string) => {
    state.customerMbeId = customerMbeId;
  },
  setCustomerInfo: (state: any, customerInfo: CustomerDTO) => {
    state.info = customerInfo;
  },
  setTaxDutyEnabled: (state: any, status: boolean) => {
    state.taxDutyEnabled = status;
  },
  setTaxDutyZonosEnabled: (state: any, status: boolean) => {
    state.taxDutyZonosEnabled = status;
  },
  setCustomerConfig: (
    state: any,
    customerConfig: OnlineMbeConfigurationDTO
  ) => {
    state.config = customerConfig;
  },
  setDepartments: (state: any, customerDepartments: DepartmentDTO[]) => {
    state.departments = customerDepartments;
  },
  setMbeServiceIds: (state: any, mbeServiceIds: number[]) => {
    state.mbeServiceIds = mbeServiceIds;
  },
  setStoreAddresses: (state: any, customerStoreAddresses: AddressDTO[]) => {
    state.storeAddresses = customerStoreAddresses;
  },
  setStoreInfo: (state: any, storeInfo: CreateStoreDTO) => {
    state.storeInfo = storeInfo;
  },
  setExtraServiceConfig: (
    state: any,
    extraServiceConfig: OnlineMBEExtraServiceDto[]
  ) => {
    state.extraServiceConfig = extraServiceConfig;
  },
  setCourierVisibilityConfig: (
    state: any,
    courierVisibilityConfig: OnlineMbeCourierVisibilityDto[]
  ) => {
    state.courierVisibilityConfig = courierVisibilityConfig;
  },
  setThermicConfig: (
    state: any,
    thermicConfig: OnlineMBEThermicConfigDto[]
  ) => {
    state.thermicConfig = thermicConfig;
  },
  setClaimConfig: (state: any, claimConfig: any) => {
    state.claimConfig = claimConfig;
  }
};

export default {
  state,
  getters,
  mutations,
  namespaced: true
};
